import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "state";
import {
  claimCampaignCreditIfEligible,
  getCampaignFromLocation,
  isCampaignCreditOffer,
  queueCampaignCreditStatus,
} from "utils/campaignCredit";
import { getDeploymentScope, TEST_PATH_PREFIX } from "utils/deploymentScope";

/** Booking path for signed-in users who land on QR registration (matches production /buchen). */
export const drHoffmannBuchenPath = () => {
  const prefix = getDeploymentScope() === "test" ? TEST_PATH_PREFIX : "";
  return `${prefix}/buchen`;
};

/** Signed-in users skip QR registration and go straight to booking (claim promo credit first). */
const QrCodeGuestGate = ({ children }) => {
  const token = useSelector((s) => s.token);
  const location = useLocation();
  const dispatch = useDispatch();
  const [redirectTo, setRedirectTo] = useState(null);

  useEffect(() => {
    if (!token) {
      setRedirectTo(null);
      return undefined;
    }

    let cancelled = false;

    const run = async () => {
      const campaign = getCampaignFromLocation(location);
      if (isCampaignCreditOffer(campaign)) {
        const result = await claimCampaignCreditIfEligible(campaign, { token });
        if (!cancelled && result?.user) {
          dispatch(setUser({ user: result.user }));
        }
        if (!cancelled && result?.alreadyClaimed && !result?.credited) {
          queueCampaignCreditStatus({
            kind: "already_claimed",
            campaign: result.campaign || campaign,
          });
        }
      }
      if (!cancelled) setRedirectTo(drHoffmannBuchenPath());
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [token, location, dispatch]);

  if (!token) return children;
  if (!redirectTo) return null;
  return <Navigate to={redirectTo} replace />;
};

export default QrCodeGuestGate;
